import axios from "axios";
import { useRecoilState } from "recoil";
import A from "../utils/url.utils.js";
import { callSettingsAtom, settingsAtom } from "../state.js";
import { mapSettingsAtom } from "../state.js";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { decryptAES } from "../utils/cryptoUtil.js";

export default function useSettings() {
  const navigate = useNavigate();
  const [settings, setSettings] = useRecoilState(settingsAtom);
  const [callSsettings, setCallSettings] = useRecoilState(callSettingsAtom);
  const [mapSettings, setMapSettings] = useRecoilState(mapSettingsAtom);
  //const { authFailure, setAdmin } = useAdmin();
  const fetchSettings = async () => {
    try {
      const { data } = await axios.get(A.HOST + A.REACT_CONFIG);

      const configData = JSON.parse(decryptAES(data));
      //console.log(configData, "jhgjhgg", data);

      if (configData?.data?.clientId) {
        const { data: callData } = await axios.post(A.HOST + A.CALL_CONFIG, {
          clientId: configData?.data?.clientId,
          isEncrypted: true,
        });

        const parsedCallData = JSON.parse(decryptAES(callData));
        setCallSettings(parsedCallData);
        //console.log(parsedCallData, "kjhg");
      }

      setSettings(configData.data);
      //Cookies.set("clientId", configData.data.clientId);
      document
        .getElementById("favicon")
        .setAttribute("href", configData.data.favicon);
      document
        .getElementById("mobile_icon")
        .setAttribute("href", configData.data.mobileLogo);
      return configData;
    } catch (err) {
      console.error(err);
      //alert("Server Under Construction, Retry later ! ");
      //authFailure(err);
      return false;
    }
  };
  const defaultDialCode =
    settings && settings.isCountryCodeNeeded ? settings.defaultDialCode : "";
  return {
    settings,
    setSettings,
    fetchSettings,
    mapSettings,
    setMapSettings,
    defaultDialCode,
  };
}
